import React from 'react';
import { Button } from '@mui/material';

function PrimaryButton({
  children,
  onClick,
  type = 'button',
  disabled = false,
  fullWidth = false,
  startIcon,
  endIcon,
  sx = {},
  ...rest
}) {
  return (
    <Button
      type={type}
      onClick={onClick}
      disabled={disabled}
      fullWidth={fullWidth}
      startIcon={startIcon}
      endIcon={endIcon}
      variant="contained"
      sx={{
        background: 'linear-gradient(90deg, #E54004 0%, #F6911D 100%)',
        color: 'white',
        fontWeight: 600,
        px: 4,
        '&:hover': { opacity: 0.9 },
        '&:disabled': {
          background: 'rgba(255, 255, 255, 0.1)',
          color: 'rgba(255, 255, 255, 0.3)',
        },
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Button>
  );
}

export default PrimaryButton;
